module.exports = __webpack_public_path__ + "components/star-rating/static/yellow/7-29e098cc9ec1c1b11a8638a3963c8d1b.svg";